module.exports = __webpack_public_path__ + "assets/img/used-icon.2c7855f2.png";